import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { backgroundConverterMap } from './backgroundPropsToCss'

/**
 * Enriches the converters registry with all Background style property converters.
 * Background converters handle CSS background properties including images, colors, positions, etc.
 */
export function enrichBackgroundConverters(): void {
	// Register all background converters
	Object.entries(backgroundConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
